export const REGISTER = [
  { label: "Legal form", value: "Association" },
  { label: "Registered office", value: "Bern (BE)" },
  { label: "Commercial register no.", value: "CH-036.6.076.139-0" },
  { label: "UID / VAT", value: "CHE-133.425.602" },
  { label: "Commercial register entry", value: "25.03.2019" },
];

export const ABOUT = [
  "Swiss Blockchain Alliance is dedicated to building secure, resilient, and compliant digital infrastructures for organizations in high-risk and highly regulated environments. We bridge the gap between technology, security operations, and governance.",
  "Our focus is on reducing vulnerabilities, strengthening security standards, and enabling companies to navigate complex digital environments securely.",
  "At the intersection of technology, compliance, and operational control, we develop scalable, long-term security solutions. We understand security as a continuous and constantly evolving process.",
  "Our specialized teams strengthen system resilience through in-depth analyses, proactive defense strategies, and continuous protective measures.",
];

export const SERVICES = [
  {
    no: "01",
    title: "Central Coordination",
    text: "We act as a central interface between technical teams, decision-makers, and compliance officers. Our structured approach supports effective coordination and consistent implementation of security measures.",
  },
  {
    no: "02",
    title: "Strengthening Resilience",
    text: "We increase operational resilience through continuous risk assessments, targeted optimization of system defenses, and ongoing adaptation of security strategies to new threats and regulatory requirements.",
  },
  {
    no: "03",
    title: "Protection of critical systems",
    text: "Multi-layered security architectures, continuous monitoring, and advanced threat detection strengthen the security, stability, and resilience of critical digital systems.",
  },
];

export const WORKING_GROUPS = [
  "Swiss Blockchain Alliance focuses on the constantly evolving landscape of cybersecurity, digital infrastructure, and emerging technologies. The need for secure, resilient, and responsibly managed digital environments continues to grow.",
  "Our approach combines advanced security frameworks with practical implementation, protecting critical systems and supporting secure digital identities, personal data protection, and transparent, auditable processes.",
];

export const MEMBER_BENEFITS = [
  "Access to an established network of specialists, organizations, and public institutions.",
  "Exchange on current developments in blockchain, cybersecurity, and digital infrastructure.",
  "Participation in working groups and joint initiatives.",
  "Visibility and connections across the Swiss blockchain ecosystem.",
];

export const PUBLICATIONS = [
  {
    slug: "netzwerksicherheit",
    code: "en",
    date: "23.04.2026",
    lang: "German / English",
    img: "/legacy/Network-Security-in-a-Distributed-Environment-800x800.webp",
    title: "Network security in a distributed environment: protecting modern systems",
    teaser: "How distributed infrastructures can be secured and operated resiliently.",
  },
  {
    slug: "identitaeten",
    code: "en",
    date: "23.04.2026",
    lang: "German / English",
    img: "/legacy/Protecting-Access-in-a-Connected-World-800x800.webp",
    title: "Digital identity security: protecting access in a connected world",
    teaser: "Securely manage identities and access across systems and organizations.",
  },
  {
    slug: "cloud-sicherheit",
    code: "en",
    date: "23.04.2026",
    lang: "German / English",
    img: "/legacy/Securing-Cloud-Environments-800x800.webp",
    title: "Securing cloud environments: best practices for modern enterprises",
    teaser: "Practical security measures for modern cloud infrastructure.",
  },
  {
    slug: "incident-response",
    code: "en",
    date: "23.04.2026",
    lang: "English",
    img: "/legacy/How-Organizations-Can-Minimize-Damage-and-Recover-Faster-800x800.webp",
    title: "Incident response planning: how organizations can minimize damage and recover faster",
    teaser: "A clear response plan helps organizations contain incidents and recover faster.",
  },
  {
    slug: "zero-trust",
    code: "en",
    date: "23.04.2026",
    lang: "English",
    img: "/legacy/Strengthening-Enterprise-Security-Through-Zero-Trust-Architecture-800x800.jpg",
    title: "Strengthening enterprise security through zero trust architecture",
    teaser: "Apply continuous verification and least-privilege access across enterprise systems.",
  },
  {
    slug: "datenschutz-digital",
    code: "en",
    date: "20.04.2026",
    lang: "English",
    img: "/legacy/b-800x800.webp",
    title: "Data protection and privacy: building trust in a digital-first world",
    teaser: "Practical principles for protecting personal data and building digital trust.",
  },
];
